// ACHTUNG: Bei Aenderungen dieses Typs bitte auch die Parallelstelle im C#-SDK anpassen. Der Typ ist sowohl im Frontend
// als auch im externen Software-Partner-Kontext relevant. Er wird zur Kommunikation per postMessage zwischen einer Host-Software
// und der eingebetteten Portal.Gui (iframe) verwendet und kann daher nicht per NSwag generiert werden, da er nicht Teil
// einer HTTP-basierten Schnittstelle ist.
import { isNullish } from "@commonHelpers/math-utils";

export enum SoftwarepartnerApiInboundMessageType {
	Export = 'export',
	NavigateToCatalogItem = 'navigateToCatalogItem',
	NavigateToUrl = 'navigateToUrl',
}

export type ISoftwarepartnerApiInboundMessage =
	| ISoftwarepartnerApiInboundExportMessage
	| ISoftwarepartnerApiInboundNavigateToCatalogItemMessage
	| ISoftwarepartnerApiInboundNavigateToUrlMessage;

export interface ISoftwarepartnerApiInboundExportMessage {
	type: SoftwarepartnerApiInboundMessageType.Export;
}

export interface ISoftwarepartnerApiInboundNavigateToCatalogItemMessage {
	type: SoftwarepartnerApiInboundMessageType.NavigateToCatalogItem;
	catalogItemGuid: string;
}

export interface ISoftwarepartnerApiInboundNavigateToUrlMessage {
	type: SoftwarepartnerApiInboundMessageType.NavigateToUrl;
	url: string;
}

// Schablone fuer den Type-Guard: alle Felder optional, aber mit konkreten Typen.
// Erlaubt sauberes Property-Narrowing innerhalb der Validierung.
interface ISoftwarepartnerApiInboundMessageCandidate {
	type?: SoftwarepartnerApiInboundMessageType;
	catalogItemGuid?: string;
	url?: string;
}

export function isSoftwarepartnerApiInboundMessage(
	data: ISoftwarepartnerApiInboundMessage | string | null | undefined
): data is ISoftwarepartnerApiInboundMessage {
	if (isNullish(data) || typeof data !== 'object') return false;
	const candidate = data as ISoftwarepartnerApiInboundMessageCandidate;
	switch (candidate.type) {
		case SoftwarepartnerApiInboundMessageType.Export:
			return true;
		case SoftwarepartnerApiInboundMessageType.NavigateToCatalogItem:
			return typeof candidate.catalogItemGuid === 'string' && candidate.catalogItemGuid.length > 0;
		case SoftwarepartnerApiInboundMessageType.NavigateToUrl:
			return typeof candidate.url === 'string'
				&& candidate.url.length > 0
				&& candidate.url.startsWith('/')
				&& !candidate.url.startsWith('//');
		default:
			return false;
	}
}
